import { ArrowDownIcon, ArrowUp, Header, IconButton } from "@datagame/ui";
import { Disclosure } from "@headlessui/react";
import { ReactNode } from "react";
import classNames from "classnames/bind";

import styles from "./Accordion.module.scss";

const cx = classNames.bind(styles);

export interface AccordionProps {
  title: string;
  children: ReactNode;
}

export const Accordion = ({ title, children }: AccordionProps) => {
  return (
    <Disclosure>
      {({ open }) => (
        <div>
          <Disclosure.Button as="div" className={cx("headerWrapper", { open })}>
            <Header variant="h6" className={styles.header}>
              {title}
            </Header>
            <IconButton className={styles.iconWrapper} icon={open ? <ArrowUp /> : <ArrowDownIcon />} />
          </Disclosure.Button>
          <Disclosure.Panel className={styles.contentWrapper}>{children}</Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};
